import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-2',
  standalone: true,
  imports: [],
  templateUrl: './modal-2.component.html',
  styleUrl: './modal-2.component.scss',
})
export class Modal2Component {}
